import { Directive, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from './value-accessor';
import * as i0 from "@angular/core";
export let BooleanValueAccessor = /*#__PURE__*/(() => {
  class BooleanValueAccessor extends ValueAccessor {
    constructor(el) {
      super(el);
    }
    writeValue(value) {
      this.el.nativeElement.checked = this.lastValue = value == null ? false : value;
    }
  }
  /** @nocollapse */
  /** @nocollapse */BooleanValueAccessor.ɵfac = function BooleanValueAccessor_Factory(t) {
    return new (t || BooleanValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  BooleanValueAccessor.ɵdir = /** @pureOrBreakMyCode */i0.ɵɵdefineDirective({
    type: BooleanValueAccessor,
    selectors: [["mri-switch"]],
    hostBindings: function BooleanValueAccessor_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("change", function BooleanValueAccessor_change_HostBindingHandler($event) {
          return ctx.handleChangeEvent($event.target.value);
        });
      }
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: BooleanValueAccessor,
      multi: true
    }]), i0.ɵɵInheritDefinitionFeature]
  });
  return BooleanValueAccessor;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
